<template>
  <div class="chooseItem" id="step-2" v-if="hasTitle">
    <div class="wrap">
      <div class="title-wrap">
        <p class="fs-36 color-black bold">
          {{ blockTitle }}
        </p>
        <a v-if="!isCompleted" :href="toSpec" class="btn btn-arr" target="_blank">
          {{ trans['more_about_builds'] }}
          <svg
            fill="none"
            height="12"
            viewBox="0 0 8 12"
            width="8"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.999999 11.4531L6 6.45313L1 1.45312"
              stroke="black"
              stroke-width="1.5"
            />
          </svg>
        </a>
        <button
          v-if="isCompleted"
          class="btn btn-link"
          @click="reset"
        >
          {{ trans.change }}
        </button>
      </div>
      <collapse-transition :duration="collapseDuration">
        <ul v-if="isActive && !isCompleted" class="checkbox-list">
          <li
            v-for="title in sortedTitles"
            :key="title.id"
            :class="titleOptionClass(title)"
            class="checkboxEl"
            @click="selectTitle(title)"
          >
            <div class="stripe"/>
            <p class="title">
              {{ buildTitle(title.title) }} <span class="fs-12">{{ title['sub_title'] }}</span>
            </p>
            <div class="cost">
              <span class="mr-1">{{ $crConverter(getBuildPrice(title) / 100, 'EUR') }}</span>
            </div>

            <div class="ui-tooltip xl-offset-left">
              <button type="button" class="ui-tooltip__btn"/>
              <div class="ui-tooltip__dropdown">These prices are shown with 21% VAT as a reference. Your exact price
                will be calculated by applying the VAT corresponding to your territory in the final purchasing process.
              </div>
            </div>

            <div class="buildBox">
              <div
                v-for="group in title.colorGroups"
                :key="group.id"
                class="group">
                <div class="buildBox__img">
                  <img
                    v-for="color in group.colors"
                    :alt="color.title"
                    :src="color.image"/>
                </div>
                <p class="buildBox__text">
                  {{ trans[group.title] }}
                </p>
              </div>
            </div>
          </li>
        </ul>
      </collapse-transition>
      <button
        v-if="isActive && !isCompleted"
        :class="confirmBtnClass"
        :disabled="isDisabled"
        class="btn btn-green ld-ext-right"
        type="button"
        @click="confirmSelected"
      >
        {{ trans.confirm }}
        <div class="ld ld-ring ld-spin"></div>
      </button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {CollapseTransition} from "@ivanv/vue-collapse-transition"

export default {
  name: "BuildTitleSelector",
  props: {
    trans: {
      required: true
    }
  },
  components: {
    'collapse-transition': CollapseTransition
  },
  computed: {
    ...mapGetters({
      steps: 'build/stepList',
      titles: 'build/titleList',
      selectedTitle: 'build/selectedBuildTitle',
      selectedModel: 'build/selectedModel',
      selectedBuild: 'build/selectedBuild',
      preselected: 'build/preselected',
      loading: 'build/selectorLoading',
    }),
    sortedTitles() {
      return this.preselected.title.list
      // let items = this.preselected.title.list;
      // let result = [];
      // let sorting = ['Halo', 'Neon', 'Diode', 'Edition one', 'Frameset', 'Frame Kit'];
      //
      // sorting.forEach(function (key) {
      //   let found = false;
      //   items = items.filter((item) => {
      //     if (!found && item.title === key) {
      //       result.push(item);
      //       found = true;
      //       return false;
      //     } else
      //       return true;
      //   })
      // })
      //
      // return result
    },
    collapseDuration() {
      return 800
    },
    toSpec() {
      if (this.preselected?.model?.completed) {
        return `/en/compare/${this.preselected.model.selected.slug}`
      }
      return null
    },
    hasTitle() {
      return this.preselected && this.preselected.title
    },
    isCompleted() {
      return this.hasTitle && this.preselected.title.completed
    },
    isActive() {
      return this.hasTitle && this.preselected.title.active
    },
    isDisabled() {
      return !this.hasTitle || this.preselected.title.selected === null || this.loading
    },
    confirmBtnClass() {
      return {
        disabled: this.isDisabled,
        running: this.loading
      }
    },
    blockTitle() {
      if (this.isCompleted) {
        return this.trans?.titles?.[this.preselected.title.selected.title]
      }

      return this.trans['choose_your_build_kit']
    }
  },
  methods: {
    buildTitle(title) {
      return this.trans?.titles?.[title] || title
    },
    getBuildPrice(title) {
      return title.price
    },
    reset() {
      this.$store.commit('build/setSelectorLoading', true)

      let preselected = {...this.preselected}

      preselected.title.selected = null

      preselected.model.completed = true
      preselected.model.active = false
      preselected.title.active = true
      preselected.title.completed = false
      // preselected.brakes.active = false
      // preselected.brakes.completed = false
      preselected.color.active = false
      preselected.color.completed = false
      preselected.size.active = false
      preselected.size.completed = false

      this.$store.commit('build/setPreselected', {...this.preselected, ...preselected})


      this.$store.dispatch('build/updatePreselected').then(ps => {
        this.$store.commit('build/setSelectorLoading', false)
        this.$store.commit('build/setPreselected', {...this.preselected, ...ps})

        history.pushState({}, "", `${location.origin}/en/choose/${this.preselected.model.selected.slug}`)
      })
    },
    selectTitle(title) {
      this.$store.commit('build/setSelectedTitle', title)
    },
    isSelected(title) {
      return this.hasTitle && this.preselected.title.selected.id === title.id
    },
    titleOptionClass(title) {
      return {
        active: this.isSelected(title)
      }
    },
    confirmSelected() {
      this.$store.commit('build/setSelectorLoading', true)

      this.$store.dispatch('build/updatePreselected').then(ps => {
        this.$store.commit('build/setSelectorLoading', false)
        this.$store.commit('build/setPreselected', {...this.preselected, ...ps})

        history.pushState({}, "", `${location.origin}${window.removeTrailingSlash(location.pathname)}/${this.preselected.title.selected.slug}`)

        setTimeout(() => {
          this.$root.$emit("scrollTo", {
            from: 2,
            to: 3
          })
        }, 250)
      })
      // this.$store.dispatch('build/selectTitle', {
      //   path: this.$path,
      //   title: this.selectedTitle,
      //   model: this.selectedModel
      // }).then(() => {
      //   this.$emit('onConfirmed')
      // }).finally(() => {
      //   this.loading = false
      // })
    }
  },
}
</script>
